import { Outlet } from "react-router";
import PublicLayout from "../public";

// Layout khusus halaman redirect pembayaran (mis. /user/billing/success).
// Sengaja TIDAK memakai LoginLayout supaya user yang sudah login tidak
// "ditendang" balik ke halaman sebelumnya oleh logika auth-bounce LoginLayout.
const BillingLayout = () => {
  return (
    <PublicLayout className="min-h-screen bg-blue-900">
      <Outlet />
    </PublicLayout>
  );
};

export default BillingLayout;
